import { parseNearAmount } from '@near-js/utils';

export default {
  ACCOUNT_ID_SUFFIX: 'testnet',
  INDEXER_API: 'https://indexer-dev.openforestprotocol.org',
  REF_FINANCE_API_ENDPOINT: 'https://testnet-indexer.ref-finance.com/',
  COINGECKO_PRICE_URL: 'https://api.coingecko.com/api/v3/simple/price',
  NODE_URL: 'https://rpc.testnet.fastnear.com',
  WALLET_URL: 'https://wallet.meteorwallet.app',
  SUCCESS_URL: process.env.REACT_APP_SUCCESS_URL || 'https://wallet-dev.openforestprotocol.org/',
  FAILURE_URL: process.env.REACT_APP_FAILURE_URL || 'https://wallet-dev.openforestprotocol.org/signin',
  DASHBOARD_URL: 'https://dashboard-dev.openforestprotocol.org',
  COLLATERAL_URL: 'https://collateral-dev.openforestprotocol.org',
  VALIDATION_URL: 'https://validation-dev.openforestprotocol.org',
  EXPLORER_URL: 'https://atlas-dev.openforestprotocol.org',

  NEAR_TOKEN_ID: 'wrap.testnet',
  OPN_CONTRACT: 'dev_v1_reward.openforest.testnet',
  OCC_CONTRACT: 'dev_v1_occ.openforest.testnet',
  USDC_CONTRACT: '3e2210e1184b45b64c8a434c0a7e7b23cc04ea7eb7a6c3c32520d03d4afcb8af',
  NFT_CONTRACT: 'dev_v1_nft.openforest.testnet',
  COLLATERAL_CONTRACT: 'dev_v1_collateral.openforest.testnet',
  METHODS: {
    storage_deposit: 'storage_deposit',
    storage_balance_bounds: 'storage_balance_bounds',
    storage_balance_of: 'storage_balance_of',
    storage_withdraw: 'storage_withdraw',
    get_user_projects: 'get_user_projects',
    get_profile: 'get_profile',
    get_planting_profile: 'get_planting_profile',
    get_uncollected_planting_rewards: 'get_uncollected_planting_rewards',
    get_collected_planting_rewards: 'get_collected_planting_rewards',
    get_profile_balances: 'get_profile_balances',
    get_collateral_stage: 'get_collateral_stage',
    get_certificates: 'get_certificates',
    ft_metadata: 'ft_metadata',
    ft_transfer: 'ft_transfer',
    ft_balance_of: 'ft_balance_of',
    mt_metadata_base_by_metadata_id: 'mt_metadata_base_by_metadata_id',
    mt_offset: 'mt_offset',
    mt_batch_transfer: 'mt_batch_transfer',
    plant_tokens: 'plant_tokens',
    revoke_planted_tokens: 'revoke_planted_tokens',
    collect_planting_rewards: 'collect_planting_rewards',
    withdraw_planting_rewards: 'withdraw_planting_rewards',
    withdraw_planted_tokens:'withdraw_planted_tokens',
  },
  ONE_NEAR_DEPOSIT: parseNearAmount('1'),
  FT_MINIMUM_STORAGE_BALANCE: parseNearAmount('0.00125'),
  FT_MINIMUM_STORAGE_BALANCE_LARGE: parseNearAmount('0.00359'),
  FT_MAXIMUM_STORAGE_BALANCE_LARGE: parseNearAmount('0.01'),
  OCC_STORAGE_BALANCE: parseNearAmount('0.008'),
  MIN_BALANCE_FOR_GAS: parseNearAmount('0.05'),
  TOKEN_TRANSFER_DEPOSIT: '1', // 1 yoctoNear
  FT_TRANSFER_GAS: '15000000000000',
  FT_STORAGE_DEPOSIT_GAS: '300000000000000',
  MAX_GAS: '300000000000000',
  PLANT_OPN_GAS: '300000000000000',
  WITHDRAW_OCC_GAS: '200000000000000',
  RECEIVE_OCC_GAS: '100000000000000',
  SEND_NEAR_GAS: '450000000000',
  PLANT_LIST:['babych7.testnet' ,
    'babych2.testnet' ,
    'greent.testnet']
};
